// 9fbef606107a605d69c0edbcd8029e5d
export default {
  AF: 'flags/afghanistan.svg',
  AL: 'flags/albania.svg',
  DZ: 'flags/algeria.svg',
  AD: 'flags/andorra.svg',
  AO: 'flags/angola.svg',
  AI: 'flags/anguilla.svg',
  AG: 'flags/antigua-and-barbuda.svg',
  AM: 'flags/armenia.svg',
  AW: 'flags/aruba.svg',
  AU: 'flags/australia.svg',
  AT: 'flags/austria.svg',
  AZ: 'flags/azerbaijan.svg',
  BS: 'flags/bahamas.svg',
  BH: 'flags/bahrain.svg',
  BD: 'flags/bangladesh.svg',
  BB: 'flags/barbados.svg',
  BY: 'flags/belarus.svg',
  BE: 'flags/belgium.svg',
  BZ: 'flags/belize.svg',
  BJ: 'flags/benin.svg',
  BM: 'flags/bermuda.svg',
  BT: 'flags/bhutan.svg',
  BO: 'flags/bolivia.svg',
  BQ: 'flags/bonaire.svg',
  BA: 'flags/bosnia-and-herzegovina.svg',
  BW: 'flags/botswana.svg',
  BR: 'flags/brazil.svg',
  BN: 'flags/brunei.svg',
  BG: 'flags/bulgaria.svg',
  BF: 'flags/burkina-faso.svg',
  BI: 'flags/burundi.svg',
  KH: 'flags/cambodia.svg',
  CM: 'flags/cameroon.svg',
  CA: 'flags/canada.svg',
  CV: 'flags/cape-verde.svg',
  KY: 'flags/cayman-islands.svg',
  CF: 'flags/central-african-republic.svg',
  TD: 'flags/chad.svg',
  CL: 'flags/chile.svg',
  CN: 'flags/china.svg',
  CX: 'flags/christmas-island.svg',
  CC: 'flags/cocos-islands.svg',
  CO: 'flags/colombia.svg',
  KM: 'flags/comoros.svg',
  CD: 'flags/democratic-republic-of-congo.svg',
  CK: 'flags/cook-islands.svg',
  CR: 'flags/costa-rica.svg',
  HR: 'flags/croatia.svg',
  CW: 'flags/curacao.svg',
  CY: 'flags/cyprus.svg',
  CZ: 'flags/czech-republic.svg',
  CI: 'flags/ca-ivoire.svg',
  DK: 'flags/denmark.svg',
  DJ: 'flags/djibouti.svg',
  DM: 'flags/dominica.svg',
  DO: 'flags/dominican-republic.svg',
  EC: 'flags/ecuador.svg',
  EG: 'flags/egypt.svg',
  SV: 'flags/el-salvador.svg',
  GQ: 'flags/equatorial-guinea.svg',
  ER: 'flags/eritrea.svg',
  EE: 'flags/estonia.svg',
  ET: 'flags/ethiopia.svg',
  FK: 'flags/falkland-islands.svg',
  FO: 'flags/faroe-islands.svg',
  FJ: 'flags/fiji.svg',
  FI: 'flags/finland.svg',
  FR: 'flags/france.svg',
  GF: 'flags/french-guiana.svg',
  PF: 'flags/french-polynesia.svg',
  GA: 'flags/gabon.svg',
  GM: 'flags/gambia.svg',
  GE: 'flags/georgia.svg',
  DE: 'flags/germany.svg',
  GH: 'flags/ghana.svg',
  GI: 'flags/gibraltar.svg',
  GR: 'flags/greece.svg',
  GL: 'flags/greenland.svg',
  GD: 'flags/grenada.svg',
  GP: 'flags/guadeloupe.svg',
  GT: 'flags/guatemala.svg',
  GG: 'flags/guernsey.svg',
  GN: 'flags/guinea.svg',
  GW: 'flags/guinea-bissau.svg',
  GY: 'flags/guyana.svg',
  HT: 'flags/haiti.svg',
  VA: 'flags/vatican-city.svg',
  HN: 'flags/honduras.svg',
  HK: 'flags/hong-kong.svg',
  HU: 'flags/hungary.svg',
  IS: 'flags/iceland.svg',
  IN: 'flags/india.svg',
  ID: 'flags/indonesia.svg',
  IQ: 'flags/iraq.svg',
  IE: 'flags/ireland.svg',
  IM: 'flags/isle-of-man.svg',
  IL: 'flags/israel.svg',
  IT: 'flags/italy.svg',
  JM: 'flags/jamaica.svg',
  JP: 'flags/japan.svg',
  JE: 'flags/jersey.svg',
  JO: 'flags/jordan.svg',
  KZ: 'flags/kazakhstan.svg',
  KE: 'flags/kenya.svg',
  KI: 'flags/kiribati.svg',
  KR: 'flags/south-korea.svg',
  KW: 'flags/kuwait.svg',
  KG: 'flags/kyrgyzstan.svg',
  LA: 'flags/lao.svg',
  LV: 'flags/latvia.svg',
  LB: 'flags/lebanon.svg',
  LS: 'flags/lesotho.svg',
  LR: 'flags/liberia.svg',
  LY: 'flags/libya.svg',
  LI: 'flags/liechtenstein.svg',
  LT: 'flags/lithuania.svg',
  LU: 'flags/luxembourg.svg',
  MO: 'flags/macao.svg',
  MK: 'flags/republic-of-macedonia.svg',
  MG: 'flags/madagascar.svg',
  MW: 'flags/malawi.svg',
  MY: 'flags/malaysia.svg',
  MV: 'flags/maldives.svg',
  ML: 'flags/mali.svg',
  MT: 'flags/malta.svg',
  MH: 'flags/marshall-islands.svg',
  MQ: 'flags/martinique.svg',
  MR: 'flags/mauritania.svg',
  MU: 'flags/mauritius.svg',
  YT: 'flags/mayotte.svg',
  MX: 'flags/mexico.svg',
  FM: 'flags/micronesia.svg',
  MD: 'flags/moldova.svg',
  MC: 'flags/monaco.svg',
  MN: 'flags/mongolia.svg',
  ME: 'flags/montenegro.svg',
  MS: 'flags/montserrat.svg',
  MA: 'flags/morocco.svg',
  MZ: 'flags/mozambique.svg',
  MM: 'flags/myanmar.svg',
  NA: 'flags/namibia.svg',
  NR: 'flags/nauru.svg',
  NP: 'flags/nepal.svg',
  NL: 'flags/netherlands.svg',
  NC: 'flags/new-caledonia.svg',
  NZ: 'flags/new-zealand.svg',
  NI: 'flags/nicaragua.svg',
  NE: 'flags/niger.svg',
  NG: 'flags/nigeria.svg',
  NU: 'flags/niue.svg',
  NO: 'flags/norway.svg',
  OM: 'flags/oman.svg',
  PK: 'flags/pakistan.svg',
  PW: 'flags/palau.svg',
  PA: 'flags/panama.svg',
  PG: 'flags/papua-new-guinea.svg',
  PY: 'flags/paraguay.svg',
  PE: 'flags/peru.svg',
  PH: 'flags/philippines.svg',
  PL: 'flags/republic-of-poland.svg',
  PT: 'flags/portugal.svg',
  QA: 'flags/qatar.svg',
  RO: 'flags/romania.svg',
  RU: 'flags/russia.svg',
  RW: 'flags/rwanda.svg',
  RE: 'flags/raunion.svg',
  BL: 'flags/saint-Barthalemy.svg',
  KN: 'flags/saint-kitts-and-nevis.svg',
  LC: 'flags/saint-lucia.svg',
  PM: 'flags/saint-Pierre and Miquelon.svg',
  VC: 'flags/saint-vincent.svg',
  WS: 'flags/samoa.svg',
  SM: 'flags/san-marino.svg',
  ST: 'flags/sao-tome-and-principe.svg',
  SA: 'flags/saudi-arabia.svg',
  SN: 'flags/senegal.svg',
  RS: 'flags/serbia.svg',
  SC: 'flags/seychelles.svg',
  SL: 'flags/sierra-leone.svg',
  SG: 'flags/singapore.svg',
  SX: 'flags/sint-maarten.svg',
  SK: 'flags/slovakia.svg',
  SI: 'flags/slovenia.svg',
  SB: 'flags/solomon-islands.svg',
  SO: 'flags/somalia.svg',
  ZA: 'flags/south-africa.svg',
  ES: 'flags/spain.svg',
  LK: 'flags/sri-lanka.svg',
  SR: 'flags/suriname.svg',
  SZ: 'flags/swaziland.svg',
  SE: 'flags/sweden.svg',
  CH: 'flags/switzerland.svg',
  TW: 'flags/taiwan.svg',
  TJ: 'flags/tajikistan.svg',
  TZ: 'flags/tanzania.svg',
  TH: 'flags/thailand.svg',
  TL: 'flags/timor-leste.svg',
  TG: 'flags/togo.svg',
  TO: 'flags/tonga.svg',
  TT: 'flags/trinidad-and-tobago.svg',
  TN: 'flags/tunisia.svg',
  TR: 'flags/turkey.svg',
  TC: 'flags/turks-and-caicos.svg',
  TV: 'flags/tuvalu.svg',
  UG: 'flags/uganda.svg',
  UA: 'flags/ukraine.svg',
  AE: 'flags/united-arab-emirates.svg',
  GB: 'flags/united-kingdom.svg',
  US: 'flags/united-states-of-america.svg',
  UY: 'flags/uruguay.svg',
  UZ: 'flags/uzbekistn.svg',
  VU: 'flags/vanuatu.svg',
  VN: 'flags/vietnam.svg',
  VG: 'flags/virgin-islands.svg',
  WF: 'flags/wallis-and-futuna.gif',
  YE: 'flags/yemen.svg',
  ZM: 'flags/zambia.svg',
  ZW: 'flags/zimbabwe.svg',
};
